import * as ActionToolbar from './ActionToolbar';
import * as AssignSupplier from "./AssignSupplier";
import * as Complete from './Complete';
import * as OfferDialog from './OfferDialog';
import * as Open from './Open';
import * as Preview from './Preview';
import * as SavedSearches from './SavedSearches';
import * as SupplierClaim from './SupplierClaim';
import * as SupplementaryFiles from './SupplementaryFiles';
import * as SupplierWordCount from './SupplierWordCount';

let supplierActions = {
  ...ActionToolbar,
  ...AssignSupplier,
  ...Complete,
  ...OfferDialog,
  ...Open,
  ...Preview,
  ...SavedSearches,
  ...SupplierClaim,
  ...SupplementaryFiles,
  ...SupplierWordCount,
};

export default supplierActions;
